const peiCode = {
  NoNecesario: 261,
  Porteador: 141,
  Beca: 140,
  Regular: 139,
  Postal: 451,
  Fisica: 452,
  AsistenteAlimentacion: 1929,
  AsistenciaMedicacion: 1997,
  AsistenteHigiene: 1930,
  AsistenteMovilidad: 1932,
  AsistentesCuidadosSaludCateterización: 1992,
  SaludAnsiedadSevera: 1994,
  SaludConductal: 2082,
  InterpretaciónLenguajeSenas: 3133,
  AsistenteSillaRuedas: 3143,
  AnsiedadSevera: 3165,
};

export default peiCode;
